import { AxiosError, AxiosRequestConfig } from "axios";
import {
    GET_AUTH_INFO_API,
    GET_AZURE_CREDENTIALS_API,
    LOGIN_API,
    LOGIN_AUTH0_API,
    ORG_ALL_INFO_API,
    ORG_CONTACT_SERVICES_API,
    ORG_MEMBERS_API,
    USER_AUTH_CREDENTIALS_API,
    USER_DATA_API,
    USER_TOKEN_REFRESH_API,
    ORG_BASIC_INFO_API,
    ORG_INVITATIONS_API,
    ORG_INVITATION_ITEM_API,
    ORG_ROLES_API,
    ORG_SET_DEFAULT_ROLE_API,
    ORG_ROLE_ITEM_API,
    ORG_UPDATE_MEMBER_ROLE_API,
    ORG_MEMBER_ITEM_API,
    ORG_SERVICE_LEVELS_API,
    ORG_SERVICE_LEVEL_ITEM_API,
    USER_NOTIFICATION_SETTINGS_API,
    SUBSCRIPTION_CUSTOMER_INFO_API,
    SUBSCRIPTION_CURRENT_PLAN_API,
    SUBSCRIPTION_PAYMENT_METHODS_API,
    SUBSCRIPTION_BILLING_HISTORY_API,
    ALL_NOTIFICATIONS_API,
    SINGLE_NOTIFICATION_API,
    READ_ALL_NOTIFICATIONS_API,
    DGROUP_MEMBER_ITEM_API,
    DGROUP_UPDATE_MEMBER_ROLE_API,
    DGROUP_SET_DEFAULT_ROLE_API,
    DGROUP_ROLE_ITEM_API,
    DGROUP_ROLES_API,
    DGROUP_INVITATION_ITEM_API,
    DGROUP_INVITATIONS_API,
    DGROUP_BASIC_INFO_API,
    DGROUP_ALL_INFO_API,
    DGROUP_MEMBERS_API,
    SUBSCRIPTION_ALL_PLANS_API,
    ACCOUNTS_API,
} from "../constants/apiEndpoints";
import { formatUrl } from "../helpers/misc";
import { apiHTTPRRequest, getResponseErrorMsg, tokenConfig } from "../helpers/request_helper";
import { AuthStoreActions } from "../redux/services/auth/actions";
import { OrgManager } from "./OrgManager/OrgManager";

class OrganizationAPI {
    static MEMBERS_API(organizationId: string): string {
        return formatUrl(ORG_MEMBERS_API, null, { organizationId });
    }

    static ALL_INFO_API(organizationId: string): string {
        return formatUrl(ORG_ALL_INFO_API, null, { organizationId });
    }

    static BASIC_INFO_API(organizationId: string): string {
        return formatUrl(ORG_BASIC_INFO_API, null, { organizationId });
    }

    static get CONTACT_SERVICES_API(): string {
        return ORG_CONTACT_SERVICES_API;
    }

    static INVITATIONS_API(organizationId: string): string {
        return formatUrl(ORG_INVITATIONS_API, null, { organizationId });
    }

    static INVITATION_ITEM_API(organizationId: string, invitationId: string): string {
        return formatUrl(ORG_INVITATION_ITEM_API, null, { organizationId, invitationId });
    }

    static ROLES_API(organizationId: string): string {
        return formatUrl(ORG_ROLES_API, null, { organizationId });
    }

    static ROLE_ITEM_API(organizationId: string, roleId: string): string {
        return formatUrl(ORG_ROLE_ITEM_API, null, { organizationId, roleId });
    }

    static SET_DEFAULT_ROLE_API(organizationId: string, roleId: string): string {
        return formatUrl(ORG_SET_DEFAULT_ROLE_API, null, { organizationId, roleId });
    }

    static UPDATE_MEMBER_ROLE_API(organizationId: string) {
        return formatUrl(ORG_UPDATE_MEMBER_ROLE_API, null, { organizationId });
    }
    static MEMBER_ITEM_API(organizationId: string, memberId: string) {
        return formatUrl(ORG_MEMBER_ITEM_API, null, { organizationId, memberId });
    }
    static SERVICE_LEVELS_API(organizationId: string) {
        return formatUrl(ORG_SERVICE_LEVELS_API, null, { organizationId });
    }
    static SERVICE_LEVEL_ITEM_API(organizationId: string, serviceLevelId: string) {
        return formatUrl(ORG_SERVICE_LEVEL_ITEM_API, null, { organizationId, serviceLevelId });
    }
}

class DealerGroupAPI {
    static MEMBERS_API(organizationId: string): string {
        return formatUrl(DGROUP_MEMBERS_API, null, { organizationId });
    }

    static ALL_INFO_API(organizationId: string): string {
        return formatUrl(DGROUP_ALL_INFO_API, null, { organizationId });
    }

    static BASIC_INFO_API(organizationId: string): string {
        return formatUrl(DGROUP_BASIC_INFO_API, null, { organizationId });
    }

    static INVITATIONS_API(organizationId: string): string {
        return formatUrl(DGROUP_INVITATIONS_API, null, { organizationId });
    }

    static INVITATION_ITEM_API(organizationId: string, invitationId: string): string {
        return formatUrl(DGROUP_INVITATION_ITEM_API, null, { organizationId, invitationId });
    }

    static ROLES_API(organizationId: string): string {
        return formatUrl(DGROUP_ROLES_API, null, { organizationId });
    }

    static ROLE_ITEM_API(organizationId: string, roleId: string): string {
        return formatUrl(DGROUP_ROLE_ITEM_API, null, { organizationId, roleId });
    }

    static SET_DEFAULT_ROLE_API(organizationId: string, roleId: string): string {
        return formatUrl(DGROUP_SET_DEFAULT_ROLE_API, null, { organizationId, roleId });
    }

    static UPDATE_MEMBER_ROLE_API(organizationId: string) {
        return formatUrl(DGROUP_UPDATE_MEMBER_ROLE_API, null, { organizationId });
    }
    static MEMBER_ITEM_API(organizationId: string, memberId: string) {
        return formatUrl(DGROUP_MEMBER_ITEM_API, null, { organizationId, memberId });
    }
}

class SubscriptionAPIGroup {
    static get CUSTOMER_INFO_API() {
        return SUBSCRIPTION_CUSTOMER_INFO_API;
    }

    static get CURRENT_PLAN_API() {
        return SUBSCRIPTION_CURRENT_PLAN_API;
    }

    static get PAYMENT_METHODS_API() {
        return SUBSCRIPTION_PAYMENT_METHODS_API;
    }

    static get BILLING_HISTORY_API() {
        return SUBSCRIPTION_BILLING_HISTORY_API;
    }

    static get ALL_PLANS_API() {
        return SUBSCRIPTION_ALL_PLANS_API;
    }
}

class NotificationsAPIGroup {
    static get LIST_API() {
        return ALL_NOTIFICATIONS_API;
    }

    static ITEM_API(notificationId: string) {
        return formatUrl(SINGLE_NOTIFICATION_API, null, { notificationId });
    }

    static get READ_ALL_API() {
        return READ_ALL_NOTIFICATIONS_API;
    }
}

export class APIManager {
    static getResponseErrorMsg = async (error: AxiosError) => {
        try {
            return error.response && error.response.data
                ? error.response.data.message
                    ? error.response.data.message
                    : error.response.data.error
                    ? error.response.data.error
                    : error.response.data instanceof Blob
                    ? JSON.parse(await error.response.data.text()).message || "Something went wrong.."
                    : error.response.data
                : error.message
                ? `${JSON.stringify(error.message, null, 2)}`
                : error
                ? `${JSON.stringify(error, null, 2)}`
                : "Something went wrong";
        } catch (err) {
            return "Something went wrong...";
        }
    };

    static async request(req: AxiosRequestConfig) {
        const token = AuthStoreActions.getUserToken();
        const organizationId = new OrgManager().getCurrentActiveOrg()?.id;
        req.url = formatUrl(req.url || "", null, { organizationId: organizationId || "" });
        const reqHeaders = tokenConfig(token || "", req.headers).headers;
        try {
            return await apiHTTPRRequest({ ...req, headers: { ...reqHeaders, "x-ausplan-org": organizationId } });
        } catch (err: any) {
            if (err.response && err.response.status === 401) {
                // TODO: Reauthenticate here and retry the request
                throw await APIManager.getResponseErrorMsg(err);
            } else throw await APIManager.getResponseErrorMsg(err);
        }
    }

    static get(endpoint: string, headers?: { [k: string]: any }) {
        return APIManager.request({
            method: "GET",
            url: endpoint,
            headers: headers,
        });
    }

    static post(endpoint: string, body: any, headers?: { [k: string]: any }) {
        return APIManager.request({
            method: "POST",
            url: endpoint,
            headers: headers,
            data: body,
        });
    }

    static put(endpoint: string, body: any, headers?: { [k: string]: any }) {
        return APIManager.request({
            method: "PUT",
            url: endpoint,
            headers: headers,
            data: body,
        });
    }

    static patch(endpoint: string, body?: any, headers?: { [k: string]: any }) {
        return APIManager.request({
            method: "PATCH",
            url: endpoint,
            headers: headers,
            data: body,
        });
    }

    static delete(endpoint: string, headers?: { [k: string]: any }) {
        return APIManager.request({
            method: "DELETE",
            url: endpoint,
            headers: headers,
        });
    }

    static ORG = OrganizationAPI;
    static DGROUP = DealerGroupAPI;
    static SUBSCRIPTION = SubscriptionAPIGroup;
    static NOTIFICATION = NotificationsAPIGroup;

    static get AUTH_INFO_API(): string {
        return GET_AUTH_INFO_API;
    }
    static get AZURE_CREDENTIALS_API(): string {
        return GET_AZURE_CREDENTIALS_API;
    }
    static get ACCOUNTS_API(): string {
        return ACCOUNTS_API;
    }
    static get REFRESH_TOKEN_API(): string {
        return USER_TOKEN_REFRESH_API;
    }
    static get AUTH0_LOGIN_API(): string {
        return LOGIN_AUTH0_API;
    }
    static get LOGIN_API(): string {
        return LOGIN_API;
    }
    static get USER_DATA_API(): string {
        return USER_DATA_API;
    }
    static get USER_NOTIFICATION_SETTINGS_API() {
        return USER_NOTIFICATION_SETTINGS_API;
    }
    static USER_AUTH_CREDS_API(checkOld?: boolean): string {
        return formatUrl(USER_AUTH_CREDENTIALS_API, typeof checkOld === "boolean" ? { checkOld: `${checkOld}` } : {});
    }
}
